import { ClientFieldDataType } from 'QuoteApp/services/endpoints/GetDetails';
import React, { useContext } from 'react';
import {
  DriverDataByFieldValueType,
  VehicleDataByFieldValueType,
  ContactInfoByFieldValueType,
} from '../formik';

export type ServerErrorsType = Partial<{
  drivers: DriverDataByFieldValueType<ClientFieldDataType['errors']>;
  vehicles: VehicleDataByFieldValueType<ClientFieldDataType['errors']>;
  contactInfo: ContactInfoByFieldValueType<ClientFieldDataType['errors']>;
}>;

export type ServerEditableType = Partial<{
  drivers: DriverDataByFieldValueType<ClientFieldDataType['editable']>;
  vehicles: VehicleDataByFieldValueType<ClientFieldDataType['editable']>;
  contactInfo: ContactInfoByFieldValueType<ClientFieldDataType['editable']>;
}>;

export type FieldDataContextType = {
  serverErrors: ServerErrorsType;
  editableFields: ServerEditableType;
  alwaysShowErrors: boolean; // used to show errors on Summary page
};

export const FieldDataContext = React.createContext<FieldDataContextType>({
  serverErrors: {},
  editableFields: {},
  alwaysShowErrors: false,
});

export const useFieldData = () => useContext(FieldDataContext);
